import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueLazyLoad from 'vue-lazyload'
import axios from 'axios'
import VueAxios from 'vue-axios'

import './assets/font/iconfont.css' // iconfont
import global_ from '../static/config/global' // 自定义配置文件
import common from './util/common.js' // 引用公共js
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import areaList from './util/area_list.js' // 省市区数据
import areaCode from './util/area_code.js' // 区号数据
import 'babel-polyfill'  // 让浏览器支持vuex Promise
import moment from 'moment' // 日期处理类库
import VueClipboard from 'vue-clipboard2' // 复制到粘贴板
import { Lazyload } from 'vant' // 懒加载
import '@vant/touch-emulator' // vant桌面端适配
import smoothscroll from 'smoothscroll-polyfill' // 滚动效果
let Mui // 只有在app中的时候加载mui
if (common.isApp()) {
    Mui = require('vue-awesome-mui')
    Vue.use(Mui)
}

VueClipboard.config.autoSetContainer = true
Vue.prototype.axios = axios
Vue.config.productionTip = false // 阻止生产消息
Vue.prototype.GLOBAL = global_
Vue.prototype.common = common
Vue.prototype.areaList = areaList
Vue.prototype.areaCode = areaCode
Vue.prototype.supermarketList = []
Vue.prototype.moment = moment
axios.defaults.baseURL = global_.BASE_URL
axios.defaults.withCredentials = true
axios.defaults.timeout = 60000
smoothscroll.polyfill()

Vue.use(VueClipboard)
Vue.use(Vant, VueAxios, axios, VueLazyLoad)
Vue.use(VueAwesomeSwiper)
Vue.use(Lazyload, {
    lazyComponent: true
})
const Bus = new Vue()

new Vue({
    el: '#app',
    router,
    render: h => h(App),
    components: { App },
    template: '<App/>',
    data() {
        return {
            Bus
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js